import React from "react";
import styles from "./EmployeeCard.module.css";
import PropTypes from "prop-types";
import axios from "axios";
import { toast } from "react-toastify";

const defaultProfileImage = "https://via.placeholder.com/150"; // Default profile image

const EmployeeCard = ({ employee }) => {
  const handleCardClick = () => {
    if (!employee.slug) {
      toast.error("Employee slug is missing!");
      return;
    }
    window.open(`/Realtors-and-Brokers/${employee.slug}`, "_blank");
  };

  return (
    <div className={styles.cardContainer} onClick={handleCardClick}>
      <div className={styles.cardFrame}>
        <div className={styles.innerCardFrame}>
          <div className={styles.profileSection}>
            <div className={styles.profileImage}>
              <img
                src={employee.photo_url || defaultProfileImage}
                alt={
                  `${employee.first_name} ${employee.last_name}` ||
                  "Profile Image"
                }
              />
            </div>
          </div>
          <div className={styles.profileDetails}>
            <h2>
              {employee.first_name} {employee.last_name || ""}
            </h2>
            <p>Role: {employee.role || "Agent"}</p>
            <p>Gender: {employee.gender || "N/A"}</p>
            <p>Languages: {employee.language || "N/A"}</p>
            <p>Years of Experience: {employee.years_of_experience || "N/A"}</p>
            <p>Specialization: {employee.specialization || "N/A"}</p>
            {/* <p>
              Social Links:{" "}
              {employee.linkedin_link ? (
                <a
                  href={employee.linkedin_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              ) : (
                "N/A"
              )}
              {employee.youtube_link && (
                <>
                  {" | "}
                  <a
                    href={employee.youtube_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    YouTube
                  </a>
                </>
              )}
              {employee.tiktok_link && (
                <>
                  {" | "}
                  <a
                    href={employee.tiktok_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    TikTok
                  </a>
                </>
              )}
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

EmployeeCard.propTypes = {
  employee: PropTypes.shape({
    slug: PropTypes.string, // Added slug to PropTypes
    email: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    gender: PropTypes.string,
    photo_url: PropTypes.string,
    language: PropTypes.string,
    years_of_experience: PropTypes.number,
    specialization: PropTypes.string,
    linkedin_link: PropTypes.string,
    youtube_link: PropTypes.string,
    tiktok_link: PropTypes.string,
  }).isRequired,
};

export default EmployeeCard;
